var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03033 1.71967C7.73744 1.42678 7.26256 1.42678 6.96967 1.71967L3.59467 5.09467C3.30178 5.38756 3.30178 5.86244 3.59467 6.15533C3.88756 6.44822 4.36244 6.44822 4.65533 6.15533L7.5 3.31066L10.3447 6.15533C10.6376 6.44822 11.1124 6.44822 11.4053 6.15533C11.6982 5.86244 11.6982 5.38756 11.4053 5.09467L8.03033 1.71967ZM4.65533 8.84467C4.36244 8.55178 3.88756 8.55178 3.59467 8.84467C3.30178 9.13756 3.30178 9.61244 3.59467 9.90533L6.96967 13.2803C7.26256 13.5732 7.73744 13.5732 8.03033 13.2803L11.4053 9.90533C11.6982 9.61244 11.6982 9.13756 11.4053 8.84467C11.1124 8.55178 10.6376 8.55178 10.3447 8.84467L7.5 11.6893L4.65533 8.84467Z",
    fill: "#090B45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.d7a07d0482c62ec53cc5a2af70480bc1.svg";
export { ForwardRef as ReactComponent };